import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";

import { FieldGroupComponent } from "./generic-editor/components/field-group.component";
import { GenericEditorComponent } from "./generic-editor/generic-editor.component";
import { Textbox1Component } from "./generic-editor/components/fields/textbox/textbox-1.component";
import { Chekbox1Component } from "./generic-editor/components/fields/checkbox/checkbox-1.component";
import { DatePickerKendoComponent } from "./generic-editor/components/fields/date-picker/date-picker-kendo.component";
import { DropdownKendoComponent } from "./generic-editor/components/fields/dropdown/dropdown-kendo.component";
import { DropdownComboKendoComponent } from "./generic-editor/components/fields/dropdown/dropdown-combo-kendo.component";
import { ErrorBoxComponent } from "./generic-editor/components/fields/validation-info/error-box.component";
import { FilePickerComponent } from "./generic-editor/components/fields/file-picker/file-picker.component";
import { MailBoxComponent } from "./generic-editor/components/fields/mail-box/mail-box.component";
import { FieldLineComponent } from "./generic-editor/components/field-line.component";
import { FilePickerViewerComponent } from "./generic-editor/components/fields/file-picker/FilePickerViewer.component";
import { FilePickerStandaloneComponent } from "./generic-editor/components/fields/file-picker/file-picker-standalone.component";
import { EntityPickerComponent } from "./generic-editor/components/fields/entity-picker/entity-picker.component";
import { AppRoutingModule } from "../../app-routing.module";
import { FilePickerModalComponent } from "./generic-editor/components/fields/file-picker/file-picker-modal.component";
import { GridWizardComponent } from "./generic-grid/components/grid-wizard.component";
import { GridWizardRowComponent } from "./generic-grid/components/grid-wizard-row.component";
import { GenericEditorEventProvider } from "./generic-editor/GenericEditorStateProvider";
import { GenericFormComponent } from "./generic-form.component";
import { GenericGridComponent } from "./generic-grid/generic-grid.component";
import { StandaloneFilePickerExample } from "./standalone-file-picker-example.component";
import { EditorWizardComponent } from "./generic-editor/components/editor-wizard.component";
import { GridLayoutService } from "./generic-grid/gird-layout.service";
import { EditorLayoutService } from "./generic-editor/services/editor-layout.service";

@NgModule({
	declarations: [
		GenericFormComponent,
		GenericGridComponent,
		GenericEditorComponent,
		FieldGroupComponent,
		Textbox1Component,
		DropdownKendoComponent,
		DropdownComboKendoComponent,
		ErrorBoxComponent,
		Chekbox1Component,
		DatePickerKendoComponent,
		FilePickerComponent,
		MailBoxComponent,
		FieldLineComponent,
		FilePickerViewerComponent,
		FilePickerStandaloneComponent,
		EntityPickerComponent,
		FilePickerModalComponent,
		GridWizardComponent,
		GridWizardRowComponent,
		StandaloneFilePickerExample,
		EditorWizardComponent,
	],
	providers: [
		GenericEditorEventProvider,
		GridLayoutService,
		EditorLayoutService,
	],
	imports: [BrowserModule, FormsModule, AppRoutingModule, ReactiveFormsModule],
	exports: [
		GenericFormComponent,
		GenericGridComponent,
		GenericEditorComponent,
		FilePickerStandaloneComponent,
		FilePickerViewerComponent,
		FilePickerModalComponent,
		GridWizardComponent,
	],
})
export class GenericFormModule {}



// WEBPACK FOOTER //
// ./app/insa-components/insa-generic-form/generic-form.module.ts